(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hoh-cart-recommendations"]) return;
  try {
    
  (() => {
    const selector = '[data-hoh-cart-recommendations]';

    const loadRecommendations = (section) => {
      if (!section || section.dataset.recommendationsLoaded === 'true') return;

      const url = section.dataset.recommendationsUrl;
      if (!url) return;

      section.dataset.recommendationsLoaded = 'true';

      fetch(url)
        .then((response) => {
          if (!response.ok) throw new Error('Cart recommendations request failed');
          return response.text();
        })
        .then((text) => {
          const container = document.createElement('div');
          container.innerHTML = text;
          const renderedSection = container.querySelector(selector);

          if (!renderedSection) return;

          section.innerHTML = renderedSection.innerHTML;

          if (section.querySelector('.hoh-cart-recommendations__inner')) {
            section.classList.add('is-loaded');
          }
        })
        .catch(() => {
          section.dataset.recommendationsLoaded = 'false';
        });
    };

    const initRecommendations = (root = document) => {
      root.querySelectorAll(selector).forEach((section) => {
        if ('IntersectionObserver' in window) {
          const observer = new IntersectionObserver((entries, instance) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              instance.unobserve(entry.target);
              loadRecommendations(entry.target);
            });
          }, { rootMargin: '260px 0px' });

          observer.observe(section);
        } else {
          loadRecommendations(section);
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initRecommendations());
    } else {
      initRecommendations();
    }

    document.addEventListener('shopify:section:load', (event) => initRecommendations(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hoh-product-recommendations"]) return;
  try {
    
  (() => {
    const selector = '[data-hoh-product-recommendations]';

    const loadRecommendations = (section) => {
      if (!section || section.dataset.recommendationsLoaded === 'true') return;
      if (section.dataset.staticRecommendations === 'true') return;

      const url = section.dataset.recommendationsUrl;
      if (!url) return;

      section.dataset.recommendationsLoaded = 'true';

      fetch(url)
        .then((response) => {
          if (!response.ok) throw new Error('Recommendations request failed');
          return response.text();
        })
        .then((text) => {
          const container = document.createElement('div');
          container.innerHTML = text;
          const renderedSection = container.querySelector(selector);

          if (renderedSection && renderedSection.innerHTML.trim().length > 0) {
            section.innerHTML = renderedSection.innerHTML;
          }
        })
        .catch(() => {
          section.dataset.recommendationsLoaded = 'false';
        });
    };

    const initRecommendations = (root = document) => {
      root.querySelectorAll(selector).forEach((section) => {
        if (section.dataset.staticRecommendations === 'true') return;

        if ('IntersectionObserver' in window) {
          const observer = new IntersectionObserver((entries, instance) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              instance.unobserve(entry.target);
              loadRecommendations(entry.target);
            });
          }, { rootMargin: '240px 0px' });

          observer.observe(section);
        } else {
          loadRecommendations(section);
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initRecommendations());
    } else {
      initRecommendations();
    }

    document.addEventListener('shopify:section:load', (event) => initRecommendations(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hoh-testimonial"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initReviewCarousel = (root) => {
      if (!root || root.dataset.reviewCarouselReady === 'true') return;
      const track = root.querySelector('[data-hoh-review-track]');
      const previous = root.querySelector('[data-hoh-review-prev]');
      const next = root.querySelector('[data-hoh-review-next]');
      if (!track || !previous || !next) return;

      root.dataset.reviewCarouselReady = 'true';
      const amount = () => Math.max(track.clientWidth * 0.88, 280);
      previous.addEventListener('click', () => track.scrollBy({ left: -amount(), behavior: 'smooth' }));
      next.addEventListener('click', () => track.scrollBy({ left: amount(), behavior: 'smooth' }));
    };

    document.querySelectorAll('.hoh-reviews').forEach(initReviewCarousel);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll?.('.hoh-reviews').forEach(initReviewCarousel);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
    (() => {
      const cartForm = document.querySelector('[data-hoh-cart-form]');
      if (!cartForm) return;

      cartForm.querySelectorAll('[data-hoh-quantity]').forEach((control) => {
        const input = control.querySelector('[data-hoh-qty-input]');
        const minus = control.querySelector('[data-hoh-qty-minus]');
        const plus = control.querySelector('[data-hoh-qty-plus]');
        if (!input || !minus || !plus) return;

        const message = control.parentElement?.querySelector('[data-hoh-cart-quantity-message]');
        const max = Number.parseInt(input.dataset.inventoryMax || control.dataset.inventoryMax || '', 10);
        const hasMax = Number.isFinite(max) && max >= 0;

        const showLimit = () => {
          if (!message || !hasMax) return;
          message.textContent = max === 1 ? 'Last one available.' : `Only ${max} available in this option.`;
          message.hidden = false;
        };

        const sync = () => {
          let value = Number.parseInt(input.value, 10);
          if (!Number.isFinite(value)) value = 0;
          value = Math.max(0, value);
          if (hasMax && value > max) {
            value = max;
            showLimit();
          } else if (message) {
            message.hidden = true;
          }
          input.value = String(value);
          plus.disabled = hasMax && value >= max;
        };

        const changeQuantity = (delta) => {
          const current = Number.parseInt(input.value, 10) || 0;
          const next = Math.max(0, current + delta);
          if (hasMax && next > max) {
            input.value = String(max);
            plus.disabled = true;
            showLimit();
            return;
          }
          input.value = String(next);
          if (message) message.hidden = true;
          plus.disabled = hasMax && next >= max;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        };

        minus.addEventListener('click', () => changeQuantity(-1));
        plus.addEventListener('click', () => changeQuantity(1));
        input.addEventListener('input', sync);
        input.addEventListener('change', sync);
        sync();
      });
    })();
  
  } catch(e) { console.error(e); }
})();
})();
